export default "__VITE_ASSET__be86252c__"